document.addEventListener('DOMContentLoaded', () => {
    const article = document.querySelector('.single-post-layout');
    if (!article) return;
    const content = article.querySelector('.post-content');
    const progress = article.querySelector('.post-reading-progress span');
    const header = document.querySelector('.kpg-hd');
    const details = article.querySelector('.post-toc details');
    const links = [...article.querySelectorAll('.post-toc a')];
    const targets = links.map(link => document.getElementById(decodeURIComponent(link.hash.slice(1))));
    const mobile = window.matchMedia('(max-width: 999px)');
    const sidebarViewport = article.querySelector('.post-sidebar-viewport');
    const sidebarScroll = article.querySelector('.post-sidebar-inner');
    const tocListFrame = article.querySelector('.post-toc-list-frame');
    const tocList = tocListFrame?.querySelector('ol');
    const updateScrollHint = () => {
        const hasMore = element => element && element.clientHeight > 0
            && element.scrollHeight - element.clientHeight - element.scrollTop > 2;
        sidebarViewport?.classList.toggle('has-more-below', !mobile.matches && !!hasMore(sidebarScroll));
        tocListFrame?.classList.toggle('has-more-below', mobile.matches && !!details?.open && !!hasMore(tocList));
    };
    let offsets = [];
    let start = 0;
    let end = 1;
    let headerOffset = 110;
    let current = -1;
    let frame = 0;

    const update = () => {
        frame = 0;
        const y = window.scrollY;
        if (progress) progress.style.transform = `scaleX(${Math.max(0, Math.min(1, (y - start) / Math.max(1, end - start)))})`;
        let active = -1;
        for (let i = 0; i < offsets.length; i++) {
            if (offsets[i] <= y + headerOffset + 24) active = i;
        }
        if (active !== current) {
            if (links[current]) links[current].removeAttribute('aria-current');
            if (links[active]) links[active].setAttribute('aria-current', 'location');
            current = active;
        }
    };
    const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
    };
    const measure = () => {
        headerOffset = Math.max(24, (header?.getBoundingClientRect().bottom || 90) + 16);
        article.style.setProperty('--post-header-offset', `${headerOffset}px`);
        offsets = targets.map(target => target ? target.getBoundingClientRect().top + window.scrollY : Infinity);
        if (content) {
            const rect = content.getBoundingClientRect();
            start = rect.top + window.scrollY - headerOffset;
            end = rect.bottom + window.scrollY - window.innerHeight;
        }
        update();
        updateScrollHint();
    };
    const setDetails = () => {
        if (details) details.open = !mobile.matches;
        measure();
    };
    links.forEach(link => link.addEventListener('click', () => {
        if (mobile.matches && details) details.open = false;
    }));
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    sidebarScroll?.addEventListener('scroll', updateScrollHint, { passive: true });
    tocList?.addEventListener('scroll', updateScrollHint, { passive: true });
    details?.addEventListener('toggle', updateScrollHint);
    mobile.addEventListener('change', setDetails);
    if (window.ResizeObserver) {
        const observer = new ResizeObserver(measure);
        if (header) observer.observe(header);
        if (content) observer.observe(content);
        if (sidebarScroll) observer.observe(sidebarScroll);
        if (tocList) observer.observe(tocList);
    }
    document.fonts?.ready.then(measure);
    setDetails();
});
